import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { IModalProps } from "../../../interfaces";
 
import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Button,
  Spinner,
} from "@material-tailwind/react";

import "../../../styles/sharedModal.css";
import useSharedDynamicModal from "../../../hooks/useSharedDynamicModal";

interface DynamicDialogProps extends IModalProps {
  handleClose: () => void;
}

const DynamicDialog: React.FC<DynamicDialogProps> = ({
  type,
  open = false,
  component,
  size,
  isFormModal,
  handleClose,
  title,
  message,
  confirmButton,
  cancelButton,
}) => {
  /* this state is used when we send promise a treatment */
  const isLoading = useSelector((state: RootState) => state.modal.isLoading);

  // Set up shared dynamic modal functionality
  const { openSharedDynamicModal, closeSharedDynamicModal } =
    useSharedDynamicModal();

  return (
   
    <Dialog
      placeholder={""}
      size={size ? size : "md"}
      open={open}
      handler={handleClose}
      className="grid" 
       onPointerEnterCapture={undefined} 
      onPointerLeaveCapture={undefined}   
       >

      {/* dialog header */}
      <DialogHeader
        placeholder={""}
        className={type === "warning"
          ? "h-10 text-red-500 text-md flex justify-start gap-3  items-center font-semibold "
          : "h-10 text-[#50799E] text-md justify-start gap-3  items-center font-semibold "}
             onPointerEnterCapture={undefined}
             onPointerLeaveCapture={undefined}      >
        
          <p className="flex justify-start items-center pt-1 gap-3 text-[#50799E] text-lg">
            {title}
          </p>
       
      </DialogHeader>
      {/* dialog body */}

      <DialogBody
        placeholder={""}
        className={type === "warning"
          ? "py-6 text-red-500 font-semibold text-sm max-h-[35rem] gap-6 overflow-y-auto"
          : `${size === "xxl" ? "max-h-[66rem]" : "max-h-[40rem]"} py-6 text-[#0F2552] font-semibold text-sm gap-6 overflow-y-auto`}
        divider 
         onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}      >
        <div className="mb-[12px]">{message}</div>

        {component}
      </DialogBody>

      {/* actions are defined below */}
      {(confirmButton || cancelButton) && (
        <DialogFooter
          style={{
            maxHeight: "5rem",
            position: "sticky",
            bottom: 0,
            background: "white",
            boxShadow: "-1px -1px 20px 0px",
            borderRadius: "0px 0px 8px 8px",
            padding: "10px",
          }}
          className="grid lg:grid-cols-2 items-center m-0 p-0 max-h-[5rem]"
          placeholder={""}  onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}        >
          <div className="flex justify-start items-center ">
            {cancelButton && (
              <Button
                type="button"
                placeholder={""}
                color={cancelButton?.backgroundColor
                  ? cancelButton?.backgroundColor
                  : ("#858585" as any)}
                className={cancelButton?.className
                  ? cancelButton?.className
                  : "mr-1 bg-[#858585]"}
                onClick={() => {
                  if (cancelButton?.handler) {
                    cancelButton?.handler();
                  } else {
                    closeSharedDynamicModal();
                  }
                } }  onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}              >
                <span>
                  {cancelButton?.text ? cancelButton.text : "annuler"}
                </span>
              </Button>
            )}
          </div>

          <div className="flex justify-end items-center">
            {confirmButton && (
              <div className="">
                {!isLoading && (
                  <Button
                    placeholder={""}
                    className={`${confirmButton.className ? confirmButton.className : "bg-[#1AA5C0]"}`}
                    color={confirmButton?.backgroundColor
                      ? confirmButton?.backgroundColor
                      : ("teal" as any)}
                    onClick={confirmButton.handler} 
               onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}                  >
                    <span>
                      {confirmButton.text ? confirmButton.text : "Confirmer"}
                    </span>
                  </Button>
                )}

                {isLoading && (
                  <Button
                    disabled={true}
                    className="bg-[#dedede]"
                    color="teal"
                    placeholder={""}   onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}                  >
                    <div className="flex items-center gap-2">
                      <Spinner onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                      <span>
                        {confirmButton.text ? confirmButton.text : "Confirmer"}
                      </span>
                    </div>
                  </Button>
                )}
              </div>
            )}
          </div>
        </DialogFooter>
      )}
      {/* end actions definition */}
    </Dialog>
  );
};

export default DynamicDialog;
